export default __webpack_public_path__ + "80c4ddeb9d64853723f0080be5306866.svg";